export const chartColors1 = [
  '#FFA061',
  '#F7EC57',
  '#FF856C',
  '#FFB9C6',
  '#FF6A6A',
  '#bd7ebe',
  '#beb9db',
  '#79B6E4',
  '#b2e061',
  '#8bd3c7',
];

export const chartColors2 = [
  '#79B6E4',
  '#b2e061',
  '#bd7ebe',
  '#beb9db',
  '#8bd3c7',
  '#FFA061',
  '#F7EC57',
  '#FF856C',
  '#FFB9C6',
  '#FF6A6A',
];
